<template>
    <v-layout align-center justify-left>
        <div class="classic-form-page">
            <mdb-mask class="d-flex view justify-content-center align-items-center">
                <mdb-row>
                    <div class="white-text text-center text-md-left col-md-8 mt-xl-10 mb-12">
                    </div>              
                    <mdb-col md="20" xl="3" class="mb-1">
                          <mdb-card-body class="z-depth-1 white-text"> 
                            <h1 class="white--text" color="white" > Acceso al Sistema</h1>
                            <br/>
                            <hr class="hr-light"/>
                           <br/>
                            <h2 class="text-left" color="white" > Email:</h2>
                                 <v-text-field v-model="email" autofocus color="white"  required>
                                </v-text-field>
                            <br/>
                            <h2 class="text-left" color="white" > Password:</h2>
                                <v-text-field v-model="password" type="password" color="white"  required>
                                </v-text-field>
                                <v-flex class="white--text"  v-id="error" >
                                  {{error}}
                                </v-flex>  
                                <div class="text-center mt-4 white-text">
                                <v-flex text-xs-right>
                                    <v-btn @click="ingresar" color="primary">Ingresar</v-btn>
                                </v-flex>
                                <hr class="hr-light"/>
                            </div>
                        </mdb-card-body> 
                    </mdb-col>
                </mdb-row>
            </mdb-mask>
        </div>
    </v-layout>
</template>




<script>
import axios from 'axios'
import { mdbContainer, mdbRow, mdbCol, mdbNavbar, mdbNavItem, mdbNavbarNav, mdbNavbarToggler, ViewWrapper, mdbMask, mdbBtn, mdbCard, mdbCardBody, mdbInput, mdbIcon, mdbNavbarBrand } from 'mdbvue';
 
export default {
   name: 'ClassicFormPage', //'ModalExamplesPage', //
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbNavbar,
      mdbNavItem,
      mdbNavbarNav,
      mdbNavbarToggler,
      ViewWrapper,
      mdbMask,
      mdbBtn,
      mdbCard,
      mdbCardBody,
      mdbInput,
      mdbIcon,
      mdbNavbarBrand      
    },

    data(){
        return {
            email: '',
            password: '',
            error: null
        }
    },
    methods : {
        ingresar(){
            this.error=null;
            axios.post('api/Usuarios/Login', {email: this.email, password: this.password})
            .then(respuesta=> {
                return respuesta.data
            })
            .then(data => {
                this.$store.dispatch("guardarToken", data.token)
                this.$router.push({name: 'Inicio'})
            })
            .catch(err => {
                console.log(err.respose)
                if(err.response.status==400){
                    this.error = "No es un email valido";
                }else if(err.response.status==404){
                    this.error = "No existe el usuario o sus datos son incorrectos";
                }else{
                    this.error = "Ocurrio un error";
                }
                console.log(err)
            })
        }
    }    
}
</script>

<style>
  .classic-form-page .view {
    background-image: url(../assets/appVecol-09.png);
    background-repeat: no-repeat;
    background-size:  cover ;
    background-position: left center;
    width: 2000px;
    height:  820px;
  }

  .classic-form-page .gradient {
    background: -webkit-linear-gradient(45deg, rgba(0, 0, 0, 0.7), rgba(72, 15, 144, 0.4) 100%);
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.7), rgba(72, 15, 144, 0.4) 100%);
  }

  .classic-form-page .card {
    background-color: rgba(126, 123, 215, 0.2);
  }

  .classic-form-page h6 {
    line-height: 1.7;
  }

  .classic-form-page .navbar {
    transition: background .5s ease-in-out,padding .5s ease-in-out;
  }

  .classic-form-page .navbar .md-form {
    margin: 0;
  }

  .top-nav-collapse {
    background: #424f95 !important;
  }

  @media (max-width: 768px) {
    .classic-form-page .navbar:not(.top-nav-collapse) {
        background: #424f95 !important;
    }
  }

  .classic-form-page label {
    color: #fff!important;
  }
</style>